import { useQuery } from "@tanstack/react-query";
import queryKeys from "./queryKeys";
import useExperimentationAPIClient from "./useExperimentationAPIClient";

export const useExperimentationQuery = (experimentationId: string) => {
    const { getExperimentation } = useExperimentationAPIClient();
    return useQuery({
        queryKey: queryKeys.getExperimentation(experimentationId, {
            depth: "3",
            preview: "nested",
        }),
        queryFn: getExperimentation,
        staleTime: Infinity,
    });
};
